
const debounced = {};

export const setDebounce = (callback: CallableFunction, id: string, time) => {
    if (debounced[id]) {
        clearTimeout(debounced[id]);
    }
    debounced[id] = setTimeout(callback, time);
};
